import { Injectable } from "@angular/core";
import { AcqnFiltersDetails } from "../due-diligence/model/AcqnFiltersDetails";
import { Subject } from "rxjs";
import { SelectItem } from "@fm-ui-adk/components-3";
import { FilterDetailsSourceType } from "../shared/enum-value";

@Injectable()
export class AcqnFilterService {

    private acqnFiltersDetails = {
        source: '',
        isInternal: false,
        openAcqnFilterSidebar: false,                
        startPeriod: "", 
        endPeriod: "",
        lender: "",
        acquisitionStatus: "All",
        supplemental: "All",
        loanRefinanceType: "All",
        smallLoanBalance: "All",
        transactionType: "All",
        requireFloodINS: "All",
        lenderList: [],
        acquisitionStatusList: [],
        supplementalList: [],
        loanRefinanceTypeList: [],
        smallLoanBalanceList: [],
        transactionTypeList: [],
        requireFloodINSList: []
        } as AcqnFiltersDetails;
    
    public acqnFiltersDetailsSub = new Subject<AcqnFiltersDetails>();
    public acqnInsuranceFiltersDetailsSub = new Subject<AcqnFiltersDetails>();

    constructor() {
        // console.log("AcqnFilterService constructor");
    }

    public setSource(source: string) {
        this.acqnFiltersDetails.source = source;
    }

    public getSource() {
        return this.acqnFiltersDetails.source;
    }

    public setIsInternal(isInternal: boolean) {     
        this.acqnFiltersDetails.isInternal = isInternal;
    }

    public setStartPeriod(startPeriod: string) {
        this.acqnFiltersDetails.startPeriod = startPeriod;
    }

    public setEndPeriod(endPeriod: string) {
        this.acqnFiltersDetails.endPeriod = endPeriod;
    }

    public setLender(lender: string) {
        this.acqnFiltersDetails.lender = lender;
    }

    public setLenderList(lenderList: any[]) {
        this.acqnFiltersDetails.lenderList = lenderList;
    }

    public setAcquisitionStatus(acquisitionStatus: string) {
        this.acqnFiltersDetails.acquisitionStatus = acquisitionStatus;
    }

    public setAcquisitionStatusList(acquisitionStatusList: any[]) {
        this.acqnFiltersDetails.acquisitionStatusList = acquisitionStatusList;
    }

    public setSupplemental(supplemental: string) {
        this.acqnFiltersDetails.supplemental = supplemental;
    }

    public setSupplementalList(supplementalList: any[]) {
        this.acqnFiltersDetails.supplementalList = supplementalList;
    }

    public setLoanRefinanceType(loanRefinanceType: string) {
        this.acqnFiltersDetails.loanRefinanceType = loanRefinanceType;
    }

    public setLoanRefinanceTypeList(loanRefinanceTypeList: any[]) {
        this.acqnFiltersDetails.loanRefinanceTypeList = loanRefinanceTypeList;
    }

    public setSmallLoanBalance(smallLoanBalance: string) {
        this.acqnFiltersDetails.smallLoanBalance = smallLoanBalance;
    }

    public setSmallLoanBalanceList(smallLoanBalanceList: any[]) {
        this.acqnFiltersDetails.smallLoanBalanceList = smallLoanBalanceList;
    }

    public setTransactionType(transactionType: string) {
        this.acqnFiltersDetails.transactionType = transactionType;
    }

    public setTransactionTypeList(transactionTypeList: any[]) {
        this.acqnFiltersDetails.transactionTypeList = transactionTypeList;
    }

    public setRequireFloodINSList(requireFloodINSList: SelectItem[]) {
        this.acqnFiltersDetails.requireFloodINSList = requireFloodINSList;
      }

    public setRequireFloodINS(requireFloodINSSelected: string) {
        this.acqnFiltersDetails.requireFloodINS = requireFloodINSSelected;
    }

    public notifySubscribers() {    
        if ( (this.acqnFiltersDetails.source === FilterDetailsSourceType.LenderRanking) ||
          (this.acqnFiltersDetails.source === FilterDetailsSourceType.Acquisitions) ||
          (this.acqnFiltersDetails.source === FilterDetailsSourceType.DataFiles) ) {
            this.acqnFiltersDetailsSub.next(this.acqnFiltersDetails);
        }
        else {
            this.acqnInsuranceFiltersDetailsSub.next(this.acqnFiltersDetails);
        }
    }

    public updateAcqnFilters(acqnFiltersDetails: AcqnFiltersDetails) {
        this.acqnFiltersDetails.source = acqnFiltersDetails.source;
        this.acqnFiltersDetails.isInternal = acqnFiltersDetails.isInternal;

        this.acqnFiltersDetails.openAcqnFilterSidebar = acqnFiltersDetails.openAcqnFilterSidebar;
        this.acqnFiltersDetails.startPeriod = acqnFiltersDetails.startPeriod;
        this.acqnFiltersDetails.endPeriod = acqnFiltersDetails.endPeriod;

        this.acqnFiltersDetails.lender = acqnFiltersDetails.lender;
        this.acqnFiltersDetails.acquisitionStatus = acqnFiltersDetails.acquisitionStatus;
        this.acqnFiltersDetails.supplemental = acqnFiltersDetails.supplemental;
        this.acqnFiltersDetails.loanRefinanceType = acqnFiltersDetails.loanRefinanceType;
        this.acqnFiltersDetails.smallLoanBalance = acqnFiltersDetails.smallLoanBalance;
        this.acqnFiltersDetails.transactionType = acqnFiltersDetails.transactionType;

        this.acqnFiltersDetails.lenderList = acqnFiltersDetails.lenderList;
        this.acqnFiltersDetails.acquisitionStatusList = acqnFiltersDetails.acquisitionStatusList;
        this.acqnFiltersDetails.supplementalList = acqnFiltersDetails.supplementalList;
        this.acqnFiltersDetails.loanRefinanceTypeList = acqnFiltersDetails.loanRefinanceTypeList;
        this.acqnFiltersDetails.smallLoanBalanceList = acqnFiltersDetails.smallLoanBalanceList;
        this.acqnFiltersDetails.transactionTypeList = acqnFiltersDetails.transactionTypeList;

        this.acqnFiltersDetailsSub.next(this.acqnFiltersDetails);
    }

    public updateAcqnInsuranceFilters(acqnFiltersDetails: AcqnFiltersDetails) {
        this.acqnFiltersDetails.source = acqnFiltersDetails.source;
        this.acqnFiltersDetails.isInternal = acqnFiltersDetails.isInternal;

        this.acqnFiltersDetails.openAcqnFilterSidebar = acqnFiltersDetails.openAcqnFilterSidebar;
        this.acqnFiltersDetails.startPeriod = acqnFiltersDetails.startPeriod;
        this.acqnFiltersDetails.endPeriod = acqnFiltersDetails.endPeriod;

        this.acqnFiltersDetails.lender = acqnFiltersDetails.lender;
        this.acqnFiltersDetails.acquisitionStatus = acqnFiltersDetails.acquisitionStatus;
        this.acqnFiltersDetails.supplemental = acqnFiltersDetails.supplemental;
        this.acqnFiltersDetails.loanRefinanceType = acqnFiltersDetails.loanRefinanceType;
        this.acqnFiltersDetails.smallLoanBalance = acqnFiltersDetails.smallLoanBalance;
        this.acqnFiltersDetails.transactionType = acqnFiltersDetails.transactionType;
        this.acqnFiltersDetails.requireFloodINS = acqnFiltersDetails.requireFloodINS;

        this.acqnFiltersDetails.lenderList = acqnFiltersDetails.lenderList;
        this.acqnFiltersDetails.acquisitionStatusList = acqnFiltersDetails.acquisitionStatusList;
        this.acqnFiltersDetails.supplementalList = acqnFiltersDetails.supplementalList;
        this.acqnFiltersDetails.loanRefinanceTypeList = acqnFiltersDetails.loanRefinanceTypeList;
        this.acqnFiltersDetails.smallLoanBalanceList = acqnFiltersDetails.smallLoanBalanceList;
        this.acqnFiltersDetails.transactionTypeList = acqnFiltersDetails.transactionTypeList;
        this.acqnFiltersDetails.requireFloodINSList = acqnFiltersDetails.requireFloodINSList;

        this.acqnInsuranceFiltersDetailsSub.next(this.acqnFiltersDetails);
    }
}

